import { render, staticRenderFns } from "./CheckBox.vue?vue&type=template&id=2937d315&scoped=true"
import script from "./CheckBox.vue?vue&type=script&lang=js"
export * from "./CheckBox.vue?vue&type=script&lang=js"
import style0 from "./CheckBox.vue?vue&type=style&index=0&id=2937d315&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2937d315",
  null
  
)

export default component.exports